// @ts-ignore — xlsx types are optional in this project
import * as XLSX from 'xlsx';

export type ExportColumn = {
  key: string;
  label: string;
};

const humanizeKey = (key: string) =>
  key
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const rowsToSheet = (
  rows: Record<string, unknown>[],
  columns?: ExportColumn[]
) => {
  if (!rows.length) {
    return XLSX.utils.aoa_to_sheet([['No data']]);
  }

  const keys =
    columns?.map((col) => col.key) ||
    Array.from(new Set(rows.flatMap((row) => Object.keys(row))));

  const headers = columns?.map((col) => col.label) || keys.map(humanizeKey);
  const body = rows.map((row) =>
    keys.map((key) => {
      const value = row[key];
      if (value == null) return '';
      if (typeof value === 'object') return JSON.stringify(value);
      return value;
    })
  );

  return XLSX.utils.aoa_to_sheet([headers, ...body]);
};

export const downloadExcel = ({
  filename,
  sheets,
}: {
  filename: string;
  sheets: { name: string; rows: Record<string, unknown>[]; columns?: ExportColumn[] }[];
}) => {
  const workbook = XLSX.utils.book_new();
  sheets.forEach((sheet) => {
    XLSX.utils.book_append_sheet(
      workbook,
      rowsToSheet(sheet.rows, sheet.columns),
      sheet.name.slice(0, 31)
    );
  });
  const safeName = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
  XLSX.writeFile(workbook, safeName);
};
